var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkModeImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.06121 6.61795C8.06121 4.55732 8.36406 2.47483 9.1371 0.700195C3.9974 2.93754 0.529297 8.18652 0.529297 14.1492C0.529297 22.1713 7.03276 28.6748 15.0549 28.6748C21.0176 28.6748 26.2665 25.2067 28.5039 20.067C26.7292 20.84 24.6449 21.1429 22.5861 21.1429C14.564 21.1429 8.06121 14.64 8.06121 6.61795Z",
    fill: "#EDEDED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkModeImage);
export default __webpack_public_path__ + "static/media/dark-mode-image.d3a4c40418a23220a043af883b7ae64a.svg";
export { ForwardRef as ReactComponent };